export default __webpack_public_path__ + "static/media/bra-arte-9.8d9fca28.webp";